// material
import { Container } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
// import { NewProgramBuilder } from '../../../../components/ProgramBuilder';
import { EditFormByInternalNameManager } from './EditFormByInternalNameManager';

// types and classes
import type { RouteComponentProps } from '@reach/router';

// ----------------------------------------------------------------------

interface FormEditByInternalNameProps extends RouteComponentProps {}
export function FormEditByInternalName(_props: FormEditByInternalNameProps) {
  const { themeStretch } = useSettings();
  // const {formId} = useParams();

  return (
    <>
      <Page title={'Forms: Edit Form (Internal Name) | Manager'}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={'Edit form'}
            links={[
              { name: 'Dashboard', href: PATH_DASHBOARD.root },
              { name: 'Edit form (Internal Name)' },
            ]}
          />
          <EditFormByInternalNameManager />
        </Container>
      </Page>
    </>
  );
}
